var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2566.7 24422 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1384344_cc",
    transform: "translate(2544 24399)",
    fill: "#cacaca"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M39.009,23.5,23.1,39.41A.994.994,0,1,0,24.49,40.8L40.4,24.891A.994.994,0,0,0,39.009,23.5Z",
    transform: "translate(0 -0.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M26.514,30.028A3.514,3.514,0,1,0,23,26.514,3.514,3.514,0,0,0,26.514,30.028Zm0-5.039a1.525,1.525,0,1,1-1.525,1.525A1.558,1.558,0,0,1,26.514,24.989Z",
    transform: "translate(-0.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M59.314,55.8a3.514,3.514,0,1,0,3.514,3.514A3.514,3.514,0,0,0,59.314,55.8Zm0,5.039a1.525,1.525,0,1,1,1.525-1.525A1.558,1.558,0,0,1,59.314,60.839Z",
    transform: "translate(-22.128 -21.927)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.36581e476c0a984158f9e19385a6e514.svg";
export { ForwardRef as ReactComponent };